import { Link } from "react-router-dom"
export default function Nav() {
    return (
        <>
            <nav>
                <Link to={"/"}><button><i class="fa-solid fa-house"></i></button></Link>
                <Link to={"/About"}><button><i class="fa-solid fa-briefcase"></i></button></Link>
                <Link to={"/Portfolio"}><button><i class="fa-solid fa-user"></i></button></Link>
                <Link to={"/Contact"}><button><i class="fa-solid fa-envelope"></i></button></Link>
            </nav>
        </>
    )
}